import data from "../../../../../src/Checkbox/Checkbox.docs.json";
import * as React from 'react';
export default {
  data,
  React
};